import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const SettingsSeoPage = lazy(() =>
  import("@/admin/pages/SettingsSeoPage").then((m) => ({ default: m.SettingsSeoPage })),
);

export const Route = createFileRoute("/admin/settings/seo")({
  component: () => (
    <Suspense fallback={null}>
      <SettingsSeoPage />
    </Suspense>
  ),
});
